import React from 'react';
import { Image as ImageIcon } from 'lucide-react';

const ImageBlockWidget = ({ config = {} }) => {
  const src = config.src || '';
  const alt = config.alt || 'Image';
  const fit = config.fit || 'contain';
  const bgColor = config.bgColor || '#ffffff';

  if (!src) {
    return (
      <div className="h-full flex flex-col items-center justify-center bg-gray-50 text-gray-400 p-4">
        <ImageIcon className="w-10 h-10 mb-2" />
        <p className="text-xs">Add an image URL in properties</p>
      </div>
    );
  }

  return (
    <div className="h-full flex items-center justify-center p-2" style={{ backgroundColor: bgColor }}>
      <img src={src} alt={alt} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: fit }} />
    </div>
  );
};

export default ImageBlockWidget;
